module.exports = __webpack_public_path__ + "img/img-11.90472015.webp";